import { CAC_TREND } from "./exampleData";
import AmountBarChart from "./AmountBarChart";

/**
 * Blended CAC by month — S&M spend divided by new paying customers, easing from
 * $2,450 to the example's steady-state $2,000 as acquisition gets more efficient.
 */
const CacChart = () => (
  <AmountBarChart
    caption="Blended CAC eases from $2,450 to $2,000 over six months — $40,000 of sales & marketing spend landing 20 new customers by June. Read it against a $6,000 LTV: a 3:1 ratio."
    data={CAC_TREND}
    seriesName="CAC"
  />
);

export default CacChart;
